<template>
    <div class="d-flex justify-center pa-md-5 mx-lg-auto">
        <v-card class="d-flex justify-center mb-6" style="max-width: 700px" elevation="2">
            <v-form class="pa-md-4 mx-lg-auto" ref="form" style="min-width: 400px" v-model="valid" lazy-validation>
                <h4 class="mb-4">{{ esEdicion ? 'EDITAR PLANTILLA' : 'NUEVA PLANTILLA' }}</h4>

                <v-text-field
                    v-model="form.tipo"
                    :rules="tipoRules"
                    label="Tipo"
                    required
                    dense
                    :disabled="esEdicion"
                />

                <v-text-field
                    v-model="form.descripcion"
                    :rules="descripcionRules"
                    label="Descripción"
                    required
                    dense
                />

                <v-checkbox
                    v-model="form.activo"
                    label="Activo"
                    dense
                    class="mt-0"
                />

                <v-divider class="my-4" />

                <h5 class="mb-2">ITEMS DE LA PLANTILLA</h5>

                <v-row dense align="center">
                    <v-col cols="12">
                        <v-autocomplete
                            dense
                            v-model="nuevoItem"
                            :items="searchResults"
                            :loading="isSearching"
                            :search-input.sync="productSearch"
                            label="Producto"
                            placeholder="Buscar producto (mín. 4 caracteres)"
                            item-text="rename"
                            item-value="id"
                            return-object
                            no-filter
                            hide-no-data
                            @change="onProductSelected"
                        >
                            <template v-slot:item="{ item }">
                                <v-chip small color="secondaryTheme" class="caption px-2" dark>{{ item.internal_id }}</v-chip>
                                <span class="caption ml-1">{{ item.rename }}</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            dense
                            v-model="nuevoItem.unidades"
                            label="Unidades"
                            type="number"
                            min="1"
                            :rules="unidadesRules"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-btn
                            block
                            color="secondaryTheme"
                            dark
                            :disabled="!nuevoItem || !nuevoItem.internal_id || !nuevoItem.unidades"
                            @click="agregarItem"
                        >
                            <v-icon left>mdi-plus</v-icon>
                            AGREGAR ITEM
                        </v-btn>
                    </v-col>
                </v-row>

                <v-col cols="12" class="grey lighten-5 mt-2" v-if="items.length > 0">
                    <v-data-table
                        :headers="headersItems"
                        :items="items"
                        class="elevation-1"
                        :items-per-page="10"
                    >
                        <template v-slot:[`item.action`]="{ item }">
                            <v-icon color="red" small @click="eliminarItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>

                <v-col cols="12" class="mt-4">
                    <v-btn
                        :loading="loading"
                        color="success"
                        class="mr-4"
                        @click="guardar"
                    >
                        GUARDAR
                    </v-btn>
                    <v-btn
                        text
                        @click="cancelar"
                    >
                        CANCELAR
                    </v-btn>
                </v-col>
            </v-form>
        </v-card>
    </div>
</template>
<script>
import { debounce } from 'lodash'

export default {
    data() {
        return {
            valid: true,
            loading: false,
            esEdicion: false,
            tipoRules: [(v) => !!v || 'El tipo es requerido'],
            descripcionRules: [],
            unidadesRules: [
                (v) => !!v || 'Las unidades son requeridas',
                (v) => (v && v > 0) || 'Debe ser mayor a 0'
            ],
            form: {
                tipo: '',
                descripcion: '',
                activo: true
            },
            items: [],
            nuevoItem: {},
            productSearch: '',
            searchResults: [],
            isSearching: false,
            headersItems: [
                { text: 'Acciones', value: 'action', sortable: false },
                { text: 'Descripción', value: 'description' },
                { text: 'Código', value: 'internal_id' },
                { text: 'Modelo', value: 'model' },
                { text: 'Unidades', value: 'unidades' }
            ]
        }
    },
    watch: {
        productSearch: debounce(function (val) {
            if (this.nuevoItem && this.nuevoItem.internal_id) return
            if (!val || val.trim().length < 4) {
                this.searchResults = []
                return
            }
            this.performSearch(val)
        }, 500)
    },
    async mounted() {
        if (this.$route.params.id) {
            this.esEdicion = true
            await this.cargarPlantilla(this.$route.params.id)
        }
    },
    methods: {
        async cargarPlantilla(id) {
            try {
                const response = await this.$store.dispatch('inventario/getPlantillas')
                if (response && response.codigoRespuesta === '00') {
                    const plantilla = (response.data || []).find((p) => p.id === Number(id))
                    if (plantilla) {
                        this.form.tipo = plantilla.tipo
                        this.form.descripcion = plantilla.descripcion
                        this.form.activo = plantilla.activo
                        let items = plantilla.items || []
                        if (typeof items === 'string') {
                            try {
                                let parsed = JSON.parse(items)
                                if (typeof parsed === 'string') parsed = JSON.parse(parsed)
                                items = Array.isArray(parsed) ? parsed : []
                            } catch (e) {
                                items = []
                            }
                        }
                        this.items = items.map((item, index) => ({
                            ...item,
                            timestamp: Date.now() + index
                        }))
                    }
                }
            } catch (error) {
                console.error('Error cargando plantilla:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'No se pudo cargar la plantilla',
                    color: 'error',
                    timeout: 3000
                })
            }
        },
        async performSearch(searchText) {
            this.isSearching = true
            try {
                const results = await this.$store.dispatch('productos/searchProductos', {
                    text: searchText,
                    idSede: this.$store.state.users.user.idSede,
                    showInternals: true
                })
                this.searchResults = results.map((p) => ({
                    ...p,
                    rename: `${p.name || p.description} | ${p.internal_id}`,
                    price: p.sale_unit_price
                }))
            } catch (error) {
                console.error('Product search error:', error)
                this.searchResults = []
            } finally {
                this.isSearching = false
            }
        },
        onProductSelected(product) {
            if (!product) return
            this.nuevoItem.id = product.id
            this.nuevoItem.description = product.name || product.description
            this.nuevoItem.internal_id = product.internal_id || ''
            this.nuevoItem.model = product.brandName || ''
            this.nuevoItem.price = product.sale_unit_price || 0
            this.nuevoItem.unidades = this.nuevoItem.unidades || 1
        },
        agregarItem() {
            if (!this.nuevoItem || !this.nuevoItem.internal_id) return
            this.items.push({ ...this.nuevoItem, timestamp: Date.now() + Math.random() })
            this.nuevoItem = {}
            this.searchResults = []
            this.productSearch = ''
            this.$nextTick(() => {
                this.$refs.form.resetValidation()
            })
        },
        eliminarItem(item) {
            this.items = this.items.filter((i) => i.timestamp !== item.timestamp)
        },
        async guardar() {
            if (!this.form.tipo) {
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'El tipo es requerido',
                    color: 'warning',
                    timeout: 3000
                })
                return
            }

            if (this.items.length === 0) {
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Debe agregar al menos un item a la plantilla',
                    color: 'warning',
                    timeout: 3000
                })
                return
            }

            this.loading = true
            try {
                const payload = {
                    tipo: this.form.tipo,
                    descripcion: this.form.descripcion,
                    items: JSON.stringify(this.items.map((i) => ({
                        id: i.id || null,
                        description: i.description,
                        internal_id: i.internal_id,
                        model: i.model,
                        unidades: i.unidades,
                        price: i.price || 0
                    }))),
                    activo: this.form.activo
                }

                if (this.esEdicion) {
                    await this.$store.dispatch('inventario/actualizarPlantilla', {
                        id: this.$route.params.id,
                        payload
                    })
                } else {
                    await this.$store.dispatch('inventario/crearPlantilla', payload)
                }

                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: this.esEdicion ? 'Plantilla actualizada correctamente' : 'Plantilla creada correctamente',
                    color: 'success',
                    timeout: 2000
                })

                this.$router.push('/logistica/equipamiento/plantillas')
            } catch (error) {
                console.error('Error guardando plantilla:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: error?.response?.data?.message || 'No se pudo guardar la plantilla',
                    color: 'error',
                    timeout: 3000
                })
            } finally {
                this.loading = false
            }
        },
        cancelar() {
            this.$router.push('/logistica/equipamiento/plantillas')
        }
    }
}
</script>
